import {Component, inject, OnInit, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgbPagination} from '@ng-bootstrap/ng-bootstrap';
import {TasLogService} from './tas-log.service';
import {PageResponse} from '../../../shared/commons/page-response';
import {ThaiDateTimePipe} from '../../../shared/commons/thai-datetime.pipe';
import {PageTitleComponent} from '../../../shared/commons/page-title/page-title.component';
import {PagesizeSelectComponent} from '../../../shared/components/pagesize-select/pagesize-select.component';

type HttpStatusTone = 'success' | 'danger' | 'warn' | 'secondary';

@Component({
  selector: 'app-tas-log-list',
  standalone: true,
  imports: [FormsModule, NgbPagination, ThaiDateTimePipe, PageTitleComponent, PagesizeSelectComponent],
  templateUrl: './tas-log-list.component.html',
  styleUrl: './tas-log-list.component.scss'
})
export class TasLogListComponent implements OnInit {
  private readonly service = inject(TasLogService);

  protected term = signal<string>('');
  protected responseCodeCategory = signal<string>('');
  protected pageData = signal<PageResponse<any>>({
    page: {size: 20, number: 0}
  } as PageResponse<any>);

  ngOnInit(): void {
    this.search();
  }

  search(page: number = 1): void {
    const params: Record<string, string | number> = {
      page: page - 1,
      size: this.pageData().page.size,
      sort: 'timeRequest,desc'
    };
    if (this.term().trim()) {
      params['term'] = this.term().trim();
    }
    if (this.responseCodeCategory()) {
      params['responseCodeCategory'] = this.responseCodeCategory();
    }
    this.service.search(params).subscribe({
      next: (res) => this.pageData.set(res),
      error: (err) => console.error(err)
    });
  }

  reset(): void {
    this.term.set('');
    this.responseCodeCategory.set('');
    this.search();
  }

  protected statusTone(code: number | undefined): HttpStatusTone {
    if (!code) {
      return 'secondary';
    }
    if (code >= 200 && code < 300) {
      return 'success';
    }
    if (code >= 400 && code < 500) {
      return 'warn';
    }
    if (code >= 500) {
      return 'danger';
    }
    return 'secondary';
  }

  protected httpStatusText(code: number | undefined): string {
    if (!code) {
      return '-';
    }
    const texts: Record<number, string> = {
      200: 'OK', 201: 'Created', 204: 'No Content',
      301: 'Moved Permanently', 302: 'Found', 304: 'Not Modified',
      400: 'Bad Request', 401: 'Unauthorized', 403: 'Forbidden',
      404: 'Not Found', 405: 'Method Not Allowed', 409: 'Conflict',
      422: 'Unprocessable Entity', 429: 'Too Many Requests',
      500: 'Internal Server Error', 502: 'Bad Gateway', 503: 'Service Unavailable',
    };
    return `${code} ${texts[code] ?? ''}`.trim();
  }
}
